import { render, staticRenderFns } from "./AcademicDataEdit.vue?vue&type=template&id=ba2b66ca&scoped=true"
import script from "./AcademicDataEdit.vue?vue&type=script&lang=js"
export * from "./AcademicDataEdit.vue?vue&type=script&lang=js"
import style0 from "./AcademicDataEdit.vue?vue&type=style&index=0&id=ba2b66ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2b66ca",
  null
  
)

export default component.exports